export enum ItalyCustomerTypeEnum {
    ItalianPhysicalPerson,
    ItalianCompany,
    NonItalianCustomer
}
